var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Button', {
    staticStyle: {
      "margin-right": "12px"
    },
    attrs: {
      "type": "error"
    },
    on: {
      "click": _vm.deleteCustomerClicked
    }
  }, [_vm._v("删除客户")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }